import reduxThunkMiddleware from "redux-thunk";
import { routerMiddleware } from "react-router-redux";
import { hashHistory } from "react-router";
import { createStore, applyMiddleware, compose } from "redux";

import { IState } from "../models";
import rootReducer from "../reducers";
import { IS_DEV } from "./";

const middlewares = [
	routerMiddleware(hashHistory), 
	reduxThunkMiddleware
];

const reduxDevTools = IS_DEV && typeof window === 'object' && window["devToolsExtension"] ? window["devToolsExtension"]() : f => f;

export function initializeStore(initialState: IState) {
	return createStore(rootReducer, initialState, compose(applyMiddleware(...middlewares), reduxDevTools));
}



// WEBPACK FOOTER //
// ./src/client/config/store.ts